const ADD_GTAG_IDENTIFIERS: boolean =
  import.meta.env.ADD_GTAG_IDENTIFIERS ?? true;

export { ADD_GTAG_IDENTIFIERS };
